@if (pageDataBkk()?.content?.length) {
  <div class="row">
    <div class="col-12">
      <ngb-pagination class="d-flex justify-content-center"
                      [maxSize]="5"
                      [rotate]="true"
                      [ellipses]="false"
                      [boundaryLinks]="true"
                      [page]="pageDataBkk()?.number + 1"
                      (pageChange)="searchBkk($event)"
                      [pageSize]="pageDataBkk()?.size"
                      [collectionSize]="pageDataBkk()?.totalElements"></ngb-pagination>
    </div>
  </div>
}

<div class="table-responsive">
  <table class="table table-striped table-bordered caption-top">
    <thead>
    <tr>
      <th nowrap class="text-center" rowspan="2">รหัสหน่วยบริการประจำ</th>
      <th nowrap class="text-start" rowspan="2">ชื่อหน่วยบริการประจำ</th>
      <th nowrap class="text-center" rowspan="2">รหัสหน่วยบริการปฐมภูมิ</th>
      <th nowrap class="text-start" rowspan="2">ชื่อหน่วยบริการปฐมภูมิ</th>
      <th nowrap class="text-center" rowspan="2">จังหวัด</th>
      <th nowrap class="text-center" colspan="3">จำนวนประชากร</th>
      <th nowrap class="text-center" colspan="3">โมเดล 5</th>
    </tr>
    <tr>
      <th nowrap class="text-center" scope="col">{{ prevMonth() }}</th>
      <th nowrap class="text-center" scope="col">{{ currentMonth() }}</th>
      <th nowrap class="text-center" scope="col">ส่วนต่าง</th>
      <th nowrap class="text-center" scope="col">{{ prevMonth() }}</th>
      <th nowrap class="text-center" scope="col">{{ currentMonth() }}</th>
      <th nowrap class="text-center" scope="col">ส่วนต่าง</th>
    </tr>
    </thead>
    <tbody>
      @for (item of pageDataBkk()?.content; let i = $index; track item) {
        <tr>
          <td class="text-center fw-semibold text-muted">{{ item.hmainOpCode || '-' }}</td>
          <td>{{ item.hmainOp?.displayNameWithoutHcode || '-' }}</td>
          <td class="text-center fw-semibold text-muted">{{ item.hsubOpCode || '-' }}</td>
          <td>{{ item.hsubOp?.displayNameWithoutHcode || '-' }}</td>
          <td>{{ item.purprovince || '-' }}</td>
          <td class="text-end">{{ (item.prevTotalMan || 0) | number }}</td>
          <td class="text-end">{{ (item.currTotalMan || 0) | number }}</td>
          <td class="text-end">{{ (item.diffTotalMan || 0) | number }}</td>
          <td class="text-end">{{ (item.prevPointModel5 || 0) | number }}</td>
          <td class="text-end">{{ (item.currPointModel5 || 0) | number : '1.4-4' }}</td>
          <td class="text-end">{{ (item.diffPointModel5 || 0) | number }}</td>
        </tr>
      } @empty {
        <tr>
          <td colspan="11">
            <app-not-found></app-not-found>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>

<div class="row">
  <div class="col-12">
    <ngb-pagination class="d-flex justify-content-center"
                    [maxSize]="5"
                    [rotate]="true"
                    [ellipses]="false"
                    [boundaryLinks]="true"
                    [page]="pageDataBkk()?.number + 1"
                    (pageChange)="searchBkk($event)"
                    [pageSize]="pageDataBkk()?.size"
                    [collectionSize]="pageDataBkk()?.totalElements"></ngb-pagination>
  </div>
</div>
